import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Incasso } from '../../../models/incasso';
import { SezioneIncassi } from '../../../models/sezioni/sezione-incassi';
import { IncassiEditComponent } from './incassi-edit.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [incasso-mod-edit]',
  templateUrl: 'incasso-mod-edit.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class IncassoModEdit {
  @Output() onReturn: EventEmitter<SezioneIncassi> = new EventEmitter<SezioneIncassi>();
  @ViewChild('formIncassoEdit') formIncasso: IncassiEditComponent;

  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();

  inizializza(sezione: SezioneIncassi, incasso: Incasso, idSezioneControparti: string, idSezioneEconomica:string, urlUpdate: string, urlReadSezioneControparti: string, urlReadSezioneEconomica: string, urlUpdatePetitumeconomico:string, fascicolo: FascicoloFull) {
    if(this.isPrd) this.formIncasso.inizializza(sezione, incasso, idSezioneControparti, urlUpdate, urlReadSezioneControparti, fascicolo);
    openModal('modalmodIncasso');
  }

  createForm() {
    if(this.isPrd) this.formIncasso.createForm();
  }

  manageModal(sezioneIncassi: SezioneIncassi) {
      closeModal('modalmodIncasso');
      this.onReturn.emit(sezioneIncassi);
  }
}
